<template>
  <div class="flex items-center justify-center min-h-48 bg-transparent">
    <div class="flex flex-col items-center space-y-4">
      <!-- Spinner -->
      <div 
        class="animate-spin rounded-full border-4 border-gray-200 border-solid border-top"
        :class="spinnerSizeClass"
      ></div>
      
      <!-- Loading Text -->
      <div v-if="showText" class="text-center">
        <h3 
          class="font-medium text-gray-700"
          :class="textSizeClass"
        >
          {{ loadingText }}
        </h3>
        <p v-if="description" class="text-sm text-gray-500 mt-1">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoader',
  
  props: {
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg', 'xl'].includes(value)
    },
    loadingText: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    spinnerSizeClass() {
      const sizes = {
        sm: 'w-6 h-6',
        md: 'w-8 h-8', 
        lg: 'w-12 h-12',
        xl: 'w-16 h-16'
      }
      return `${sizes[this.size]}`
    },
    
    textSizeClass() {
      const textSizes = {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
        xl: 'text-xl'
      }
      return textSizes[this.size]
    }
  }
}
</script>

<style scoped>
.border-top{
  border-top: 4px solid #3490dc !important; 
}
</style>